// Mono-style section label: // 01 SERVICES
export default function SectionLabel({ num, children }) {
  return (
    <div className="sec-label" data-testid={`sec-label-${num}`}>
      // <span className="num">{String(num).padStart(2, "0")}</span> {children}
    </div>
  );
}
